/**
 * The slot registrations of `web/history` (1.V-2 deliverable 22): the History tab
 * (`rail.tabs.history`). `apps/web/src/editor-services/slots.ts` collects them as
 * `SLOT_MODULES['web/history']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { lazy } from 'react';

/**
 * Loaded on first use: the tab reads the editor package (`useEditorHandle`), which this module's
 * importers (the slot collector, its specs) need not evaluate; the rail shows it in a `Suspense`.
 */
const HistoryTab = lazy(() =>
  import('./history-tab.js').then((module) => ({ default: module.HistoryTab })),
);

export const owner: WorkPackageId = '1.V-2';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'rail.tabs', order: 30, owner: '1.V-2', component: HistoryTab },
];
